// Extracted verbatim (programmatically, not hand-transcribed) from
// SCERS_Retirement_Calculator_v6_0_7.html on 2026-09-22.
// Do not hand-edit these values. If the source calculator is revised, re-run the
// extraction script against the new version and regenerate this file.

export const SERVICE_CREDITS_PER_YEAR = 2088.0;
export const INTEREST = 0.0675;
